import React from "react";
import Tables from "../../components/Tables";

export default function Voicemessage() {
  return (
    <>

    </>
  );
}
